export const PHOTOVOLTAIC_STRATEGIES = {
    MAX_YEARLY_PRODUCTION: 'Maximize Yearly Production',
    MATCH_YEARLY_DEMAND: 'Match Yearly Demand',
    MAX_DEMAND_PEAKS: 'Maximize Demand Peaks Match',
};
export const SOLAR_HEAT_GAIN_STRATEGIES = {
    MANUAL: 'Manual',
    MATCH_HEATING_PEAKS: 'Match Heating Peaks Demand',
};
